export const IUX_URL = (iuxUrl: string) =>
  `${iuxUrl}/tmpl/home.tmpl?embedded=true&hideNav=true#!`;

export const ROUTE_MAPPINGS = {
  '/': '/web_com/View_Workspace',
  '/iux/compose': '/web_com/NewMessage',
  '/iux/contacts':
    '/web_tem/Contact_List.fm?&mode=list&action=View&entity=Contact',
};

export const REQUEST_TYPE = {
  IUX_NAVIGATION: 'iux_navigation',
  TOKEN_REQUEST: 'token_request',
};

export const EVENT_TYPE = {
  WSP_ROUTER: 'wsp_router',
};

export const EVENT_RESPONSE = {
  TOKEN_RESPONSE: 'token_response',
};

export const FRAGMENT_REGEX = /[?&]rd=\d+/;
